import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import type { Country } from '@fitness-force/models';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  GetCountry(BASE_URL: string): Observable<Country[]> {
    const url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_COUNTRY;
    return this.http.get(url, { headers: this.httpOptions.headers }).pipe(map((res: any) => {
      if (res) {
        return res;
      } else {
        throwError;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }
}